export const formDrawerDe = {
  "FormDrawer.save": "speichern", "FormDrawer.cancel": "abbrechen", "FormDrawer.close": "schließen", "FormDrawer.loading": "Laden…",
} as const;
export const formDrawerEn = {
  "FormDrawer.save": "save", "FormDrawer.cancel": "cancel", "FormDrawer.close": "close", "FormDrawer.loading": "Loading…",
} as const;
export const formDrawerIt = {
  "FormDrawer.save": "salva", "FormDrawer.cancel": "annulla", "FormDrawer.close": "chiudi", "FormDrawer.loading": "Caricamento…",
} as const;
export const formDrawerRu = {
  "FormDrawer.save": "сохранить", "FormDrawer.cancel": "отмена", "FormDrawer.close": "закрыть", "FormDrawer.loading": "Загрузка…",
} as const;
export const formDrawerUk = {
  "FormDrawer.save": "зберегти", "FormDrawer.cancel": "скасувати", "FormDrawer.close": "закрити", "FormDrawer.loading": "Завантаження…",
} as const;
